import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const INDUSTRIES = [["saas", "SaaS"], ["ecommerce", "E-commerce"], ["fintech", "Fintech"], ["healthcare", "Healthcare"], ["other", "Other"]];
const WIRE_TIERS = [["premium", "Premium"], ["standard", "Standard"], ["budget", "Budget"]];

export default function CompareInputs({ side, setSide, testPrefix }) {
  const updInput = (k, v) => setSide({ ...side, inputs: { ...side.inputs, [k]: v } });
  const updCost = (k, v) => setSide({ ...side, inputs: { ...side.inputs, costs: { ...side.inputs.costs, [k]: v } } });
  const upd = (patch) => setSide({ ...side, ...patch });

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-2 block">Model</Label>
          <Tabs value={side.model_type} onValueChange={(v) => upd({ model_type: v })}>
            <TabsList data-testid={`${testPrefix}-model-tabs`} className="bg-slate-100 rounded-sm h-8 text-xs">
              <TabsTrigger value="b2c" className="text-xs">B2C</TabsTrigger>
              <TabsTrigger value="b2b" className="text-xs">B2B</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
        <Select label="Wire tier" value={side.wire_tier} onChange={(v) => upd({ wire_tier: v })} options={WIRE_TIERS} testid={`${testPrefix}-wire-tier`} />
      </div>

      <Select label="Industry" value={side.industry} onChange={(v) => upd({ industry: v })} options={INDUSTRIES} testid={`${testPrefix}-industry`} />

      <div className="grid grid-cols-2 gap-3">
        <NumField label="Baseline traffic" value={side.inputs.baseline_traffic} onChange={(v) => updInput("baseline_traffic", v)} testid={`${testPrefix}-baseline-traffic`} />
        <NumField label="Lift %" value={side.inputs.lift_pct} onChange={(v) => updInput("lift_pct", v)} suffix="%" testid={`${testPrefix}-lift-pct`} />
        <NumField label="Conv rate" value={side.inputs.conv_rate} onChange={(v) => updInput("conv_rate", v)} suffix="%" testid={`${testPrefix}-conv-rate`} />
        <NumField label={side.model_type === "b2b" ? "Deal size" : "AOV"} value={side.inputs.aov} onChange={(v) => updInput("aov", v)} testid={`${testPrefix}-aov`} />
        {side.model_type === "b2b" && (
          <NumField label="LTV" value={side.inputs.ltv} onChange={(v) => updInput("ltv", v)} testid={`${testPrefix}-ltv`} />
        )}
        <NumField label="Timeframe (mo)" value={side.inputs.timeframe_months} onChange={(v) => updInput("timeframe_months", v)} testid={`${testPrefix}-timeframe`} />
      </div>

      <div className="pt-3 border-t border-slate-100">
        <Label className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-3 block">Costs</Label>
        <div className="grid grid-cols-2 gap-3">
          {[
            ["writing", "Writing"], ["agency", "Agency"], ["distribution", "Distribution"],
            ["design", "Design"], ["paid_amplification", "Paid amp."], ["tracking", "Tracking"],
          ].map(([k, l]) => (
            <NumField key={k} label={l} value={side.inputs.costs[k]} onChange={(v) => updCost(k, v)} testid={`${testPrefix}-cost-${k}`} />
          ))}
        </div>
      </div>
    </div>
  );
}

function NumField({ label, value, onChange, suffix, testid }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-[10px] uppercase tracking-[0.15em] text-slate-500">{label}</Label>
      <div className="relative">
        <Input
          data-testid={testid}
          type="number"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
          className="rounded-sm border-slate-200 h-9 text-sm pr-7"
        />
        {suffix && <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-slate-400 mono">{suffix}</span>}
      </div>
    </div>
  );
}

function Select({ label, value, onChange, options, testid }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-[10px] uppercase tracking-[0.15em] text-slate-500">{label}</Label>
      <select
        data-testid={testid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-sm border border-slate-200 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0055FF] h-9"
      >
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
